<template>
  <b-card>

    <b-row>
      <b-col class="col-1 p-2">
        Text Input
      </b-col>
      <b-col class="col-5">
        <b-form-input
          type="text"
          v-model="textValue"
          @focus="onFocus1"

          id="text-01"
          v-on="listeners()"
          :readonly="readonly('text-01')"
          @update="textValue = value('text-01')"
          dynamic-scan="on"
          data-component-name="Text Input Field"
        >
        </b-form-input>
      </b-col>

      <b-col class="col-1 p-2">
        Password Input
      </b-col>
      <b-col class="col-5">
        <b-form-input
          type="password"
          v-model="passwordValue"

          id="password-01"
          v-on="listeners()"
          :readonly="readonly('password-01')"
          @update="passwordValue = value('password-01')"
          dynamic-scan="on"
          data-component-name="Password Input Field"
        >
        </b-form-input>
      </b-col>
    </b-row>

    <component
      v-for="item in components"
      :is="item.component"
      :key="item.id"
      :id="item.id"
      :ref="item.ref"
      v-bind="item.props"
      v-on="item.events"
    ></component>
  </b-card>
</template>

<script>
export default {
    data() {
        return {
            textValue : "",             // Text Value
            passwordValue : "",         // Password Value

            componentmap: {},           // map for component's id
            components: [],             // components information
        }
    },
    created() {
    },
    mounted() {
        this.init();
    },
    methods: {
        onFocus1(e) {
            console.log("Original Handler", e.target);
        },

        init() {
            this.$children.forEach(child => {
                if("dynamic-scan" in child.$attrs) {
                    // console.log("mounted child", child);
                    // 식별값을 기준으로 동적컴포넌트를 제어하기 위해 id 속성정의 여부를 검증
                    const id = child.id || child.name;
                    if(!id) {
                        const msg = "The id or name attribute must be defined in the input form.";
                        console.log(msg);
                        return false;
                    }
                    // 이미 초기화된 상태인지 검증
                    if(id in this.componentmap) {
                        const msg = "It has already been initialized or the id or name attribute of the input form is duplicated.";
                        console.log(msg);
                        return false;
                    }

                    // 동적 컴포넌트의 고유식별값 생성
                    const component_id = "dynamic-component-" + id
                    // 동적 컴포넌트의 고유식별값과 입력양식 고유식별값 매핑
                    this.componentmap[id] = component_id;
                    // const component = (() => import('./DynamicComponent'));
                    // 동적 컴포넌트 배열정의
                    this.components.push({
                        component : () => import('./DynamicComponent'),
                        id: component_id,         // 고유식별값
                        ref: component_id,        // 접근제어를 위한 참조값
                        props: {                  // 동적 컴포넌트 추가 속성
                            parent : child,       // 부모 컴포넌트 전달
                            id: component_id,     // 동적 컴포넌트 고유식별값
                        },
                        events : {                // 동적 컴포넌트에서 발생하는 이벤트 정의
                            update: (arg) => {
                                // console.log("Event from Dynamic Components", arg);
                                child.$emit("update", arg);       // 동적 컴포넌트 이벤트 발생시 해당 입력양식의 이벤트로 전달
                            }
                        },
                    });
                }
            });
        },

        // 입력양식의 동적 이벤트 추가
        listeners() {
            const _this = this;
            const ret = {};

            ret.focus = (e) => {
                // console.log(e);
                _this.focusHandler(_this, e);
            }

            return ret;
        },
        // 포커스 이벤트 처리 핸들러
        focusHandler(instance, e) {
            console.log("Focus Handler", e.target);
            const type = e.type;
            const targetid = e.target ? e.target.id || e.target.name : "";

            // Hide All
            Object.keys(this.componentmap).forEach((id) => {
                this.hide(id);
            });

            // Show Component
            if(targetid in this.componentmap) {
                this.show(targetid);
            }
        },

        // 입력양식의 읽기전용 속성 제어
        readonly(id) {
            return id in this.componentmap
        },

        // 동적 컴포넌트에서 값을 읽어오기 위한 함수
        value(id) {
            const component_id = this.componentmap[id];
            // console.log("Component 1", component_id);
            let val = "";
            if(id in this.componentmap && component_id in this.$refs) {
                const component = this.$refs[component_id];
                // console.log("Component 2", component);
                if(component && Array.isArray(component)) {
                    component.forEach(comp => {
                        // console.log("Component 3", comp);
                        val = comp.value();
                    })
                } else {
                    val = component.value();
                }
            }
            return val;
        },
        // 동적 컴포넌트의 보이기/숨기기를 제어하기 위한 함수
        visible(id, vis) {
            const component_id = this.componentmap[id];
            // console.log("Component 1", component_id);
            // console.log(component_id, _this.vue);
            if(id in this.componentmap && component_id in this.$refs) {
                const component = this.$refs[component_id];
                // console.log("Component 2", component);
                if(component && Array.isArray(component)) {
                    component.forEach(comp => {
                        // console.log("Component 3", kpd);
                        // console.log(kpd);
                        vis ? comp.show() : comp.hide();
                    })
                } else {
                    vis ? component.show() : component.hide();
                }
            }
        },
        // 동적 컴포넌트의 보이기
        show(id) {
            this.visible(id, true);
        },
        // 동적 컴포넌트의 숨기기
        hide(id) {
            this.visible(id, false);
        },
    }
}
</script>